<template>
  <div class="tabs_content">
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
            :omit-default="['id_remote']"
        >
          <p>
            <translate class="translate">Délka</translate>:<br/> {{ duration }}</p>
          <p>
            <translate class="translate">Zdroj</translate>:<br/><a @click="goToOrigin(entity.origin_show_url)" v-translate>Pořad</a> <span> | </span> <a @click="goToOrigin(entity.origin_vod_video_url)" v-translate>Vod video</a></p>
          <p>
            <translate class="translate">Poskytovatel videa</translate>:<br/> <a @click="onProviderNameClick">{{ entity.vod_provider_name }}</a></p>
          <p>
            <translate class="translate">Typ</translate>:<br/> {{ typeText }}<br/><span v-if="entity.is_serial">(<a @click="goToEpisodes($event, entity.id_show)">Zobrazit dostupné díly</a>)</span></p>
          <p v-if="loadedTags">
            <translate class="translate" >Štítky</translate>:<br/> {{ tagNames }}</p>
          <p v-if="loadedCountries">
            <translate class="translate">Státy</translate>:<br/> {{ countryNames }}</p>
        </detail-entity-info>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input id="vodvideoname"
                      :required="true"
                      v-model="entity.name"
                      :disabled="true"
                      ref="nameref"
          >
            <translate class="translate">Název</translate>
          </text-input>
          <text-input id="vodvideomaturityrating"
                      :required="true"
                      v-model="maturityRatingText"
                      :disabled="true"
                      ref="maturityratingref"
          >
            <translate class="translate">Věkové omezení</translate>
          </text-input>
          <date-picker id="vodvideoprovidedfrom"
                      v-model="entity.provided_from"
                      :disabled="true"
                      ref="providedfromref"
          >
            <translate class="translate">Poskytováno od</translate>
          </date-picker>
          <checkbox-input id="vodvideoactive"
                          :required="true"
                          v-model="entity.active"
                          :disabled="true"
                          ref="activeref"
          >
            <translate class="translate">Aktivní</translate>
          </checkbox-input>
          <text-input id="vodvideowidth"
                      v-model="entity.content.video.width"
                      :disabled="true"
                      ref="widthref"
          >
            <translate class="translate">Šířka videa</translate>
          </text-input>

          <text-input id="vodvideoheight"
                      v-model="entity.content.video.height"
                      :disabled="true"
                      ref="heightref"
          >
            <translate class="translate">Výška videa</translate>
          </text-input>

          <text-input id="vodvideoframerate"
                      v-model="entity.content.video.framerate"
                      :disabled="true"
                      ref="framerateref"
          >
            <translate class="translate">Framerate</translate>
          </text-input>

          <text-input id="vodvideoaspectratio"
                      v-model="entity.content.video.aspect_ratio"
                      :disabled="true"
                      ref="aspectratioref"
          >
            <translate class="translate">Poměr stran</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="vodvideosourcestate"
                      :required="true"
                      v-model="sourceState"
                      :disabled="true"
                      ref="sourcestateref"
          >
            <translate class="translate">Stav zpracování na zdroji</translate>
          </text-input>
          <text-input id="vodvideolocalstate"
                      :required="true"
                      v-model="localState"
                      :disabled="true"
                      ref="localstateref"
          >
            <translate class="translate">Stav lokálního zpracování</translate>
          </text-input>
          <date-picker id="vodvideoprovidedto"
                      v-model="entity.provided_to"
                      :disabled="true"
                      ref="providedtoref"
          >
            <translate class="translate">Poskytováno do</translate>
          </date-picker>
          <p class="field field_poster">
            <label v-translate>Poster</label>
            <label class="poster add_profile_image">
													<span v-if="entity.image.poster">
														<img :src="entity.image.poster">
													</span>
            </label>
          </p>
          <p class="field field_poster">
            <label v-translate>Fotka</label>
            <label class="photo add_profile_image">
              <span v-if="entity.image.landscape">
                <img :src="entity.image.landscape">
              </span>
            </label>
          </p>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Audio</h2>
      </div>
      <div class="right">
        <table>
          <tr>
            <th v-translate>Jazyk</th>
            <th v-translate>Typ výstupu</th>
            <th v-translate>Počet kanálů</th>
            <th v-translate>Zvuková stopa pro nevidomé</th>
            <th v-translate>Komentářový doprovod</th>
          </tr>
          <template v-if="entity.content.audio.length > 0">
          <tr v-for="(item, key) in entity.content.audio" v-bind:key="'item_'+key">
            <td class="nowrap"><strong>{{item.language}}</strong></td>
            <td class="nowrap">{{item.channels_layout}}</td>
            <td class="nowrap">{{item.channels}}</td>
            <td class="nowrap">
              <img
                  class="is_set"
                  src="../../../../assets/images/is-set.svg"
                  :alt="'Ano' | translate"
                  v-if="item.impaired">
              <img
                  class="is_set"
                  src="../../../../assets/images/isnot-set.svg"
                  :alt="'NE' | translate"
                  v-else>
            </td>
            <td class="nowrap">              <img
                class="is_set"
                src="../../../../assets/images/is-set.svg"
                :alt="'Ano' | translate"
                v-if="item.comment">
              <img
                  class="is_set"
                  src="../../../../assets/images/isnot-set.svg"
                  :alt="'NE' | translate"
                  v-else></td>
          </tr>
          </template>
          <tr v-else>
            <td colspan="5" v-translate>Žádné informace o audiu</td>
          </tr>
        </table>
      </div>
    </section>
    <section>
      <div class="left">
        <h2 v-translate>Titulky</h2>
      </div>
      <div class="right">
        <table>
          <tr>
            <th v-translate>Jazyk</th>
          </tr>
          <template v-if="entity.content.subtitles.length > 0">
          <tr v-for="(item, key) in entity.content.subtitles" v-bind:key="'subtitles_'+key">
            <td class="nowrap"><strong>{{item.language}}</strong></td>
          </tr>
          </template>
          <tr v-else>
            <td v-translate>Žádné informace o titulcích</td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>
<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import date from "../../../mixins/global/date";
import vodVideo from "../mixins/vodVideo";
import {iso6391ToIso6392} from "../../../../utils/helpers";

export default {
  name: "Settings",
  components: {DetailEntityInfo},
  mixins: [date, vodVideo],
  props: {
    entity: Object
  },
  data(){
    return {
      tags: {},
      countries: {},
      loadedTags: false,
      loadedCountries: false,
    }
  },
  created(EpgCacheService){
    this.epgCacheService = EpgCacheService;

    this.epgCacheService.getTagsSimpleList({lng_priority: iso6391ToIso6392(this.$store.getters.getLanguage)})
        .then((data) => {
          data['tags'].forEach((item) => {
            this.tags[item.id] = item.text;
          });
          this.loadedTags = true;
        });

    this.epgCacheService.getCountriesSimpleList({lng_priority: iso6391ToIso6392(this.$store.getters.getLanguage)})
        .then((data) => {
          data['countries'].forEach((item) => {
            this.countries[item.id] = item.text;
          });
          this.loadedCountries = true;
        });
  },
  computed: {
    sourceState(){
      return this.getSourceStateText(this.entity.source_state);
    },
    localState(){
      return this.getLocalStateText(this.entity.local_state);
    },
    maturityRatingText(){
      let result = this.entity.maturity_rating;
      if(result === 'Všechny věkové kategorie'){
        result = this.$gettext('Všechny věkové kategorie');
      }

      return result;
    },
    tagNames(){
      let tagNames = [];
      if(this.entity.tag_ids){
        this.entity.tag_ids.forEach((item) => {
          if(this.tags.hasOwnProperty(item)){
            tagNames.push(this.tags[item]);
          }
        });
        return tagNames.join(', ');
      }else{
        return this.$gettext('Neuvedeno');
      }
    },
    countryNames(){
      let countryNames = [];
      if(this.entity.country_ids){
        this.entity.country_ids.forEach((item) => {
          if(this.countries.hasOwnProperty(item)){
            countryNames.push(this.countries[item]);
          }
        });
        return countryNames.join(', ');
      }else{
        return this.$gettext('Neuvedeno');
      }
    },
    duration() {
      if(this.entity.duration_seconds){
        return this.$_formatMinutesToString(this.entity.duration_seconds / 60);
      }else{
        return this.$gettext('Neuvedeno');
      }
    },
    typeText(){
      if(this.entity.is_serial){
        return this.$gettext('Seriál');
      }else{
        return this.$gettext('Film');
      }
    },
  },
  methods: {
    onProviderNameClick() {
      this.$router.push({name: 'vodProvidersDetail', params: {id: this.entity.id_vod_provider}})
    },
    goToEpisodes(e, id_show) {
        this.$router.push({name: 'vodEpisodes', params: {id: id_show}})
    },
    goToOrigin(url) {
      window.open(url, '_blank');
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/views/vodVideos/detail/Settings.vue